/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid2, Container, LinearProgress, Typography } from "@mui/material";
import { fetchBinaryDetails } from "../../Services/redux/AddNewApkFIleCreateRelease/AddNewApkFileCreateReleaseActions";
import { FileUploader } from "react-drag-drop-files";
import ApplicationDetailsErrorDialog from "../ApplicationDetailsErrorDialog/ApplicationDetailsErrorDialog";
import PropTypes from "prop-types";
import "./ApplicationFileAPKUpload.css";

function ApplicationFileAPKUpload({ checkAllTabsAreTrue }) {
  const dispatch = useDispatch();
  const appData = useSelector(
    (state) => state.applicationDetails.applicationDetails
  );
  const submissionData = useSelector(
    (state) => state.submissionDetails.submissionDetails
  );
  const binaryDetails = useSelector((state) => state.binaryDetails);
  const errors = useSelector((state) => state.errors);
  const [appId, setAppId] = useState("");
  const [submissionId, setSubmissionId] = useState("");
  const [fileName, setFileName] = useState("");
  const [uploaderKey, setUploaderKey] = useState(0);
  const handleFileChange = (file) => {
    console.log("Selected file:", file);
    setFileName(file.name);
    dispatch(fetchBinaryDetails(appId, submissionId, file));
  };
  useEffect(() => {
    if (appId && appId.length > 0 && sessionStorage.getItem("submissionId")) {

      if(!submissionData.binary && Object.keys(binaryDetails.binary).length > 0) {

        checkAllTabsAreTrue(false);
      }
      
    }
  }, [binaryDetails]);

  useEffect(() => {
    setAppId(appData.id);
    setSubmissionId(submissionData.id);
  }, [appData, submissionData]);

  useEffect(() => {
    if (errors?.errorMessage !== null && errors?.errorType !== null) {
      setFileName("");
      setUploaderKey(prev => prev + 1);
    }
  }, [errors]);

  return (
    <Container maxWidth="lg">
      <Grid2 container justifyContent="flex-start" alignItems="center">
        <Grid2 size={12}>
          <div className="APKfileUploadSection">
            {binaryDetails.loading ? (
              <div className="fileUploadFileDiv">
                <label htmlFor="apk-file-upload" className="labelNameAPK">APK File<span className="required">*</span></label>
                <div className="fileLabelClsAPK">
                  Upload an APK file to create a new release of the app
                </div>
                <FileUploader id="apk-file-upload"                  
                  key={uploaderKey}
                  classes="fileContentClsUploadCreateNewRelease"
                  multiple={false}
                  handleChange={handleFileChange}
                  name="file"
                  label="Browse or Drag & drop the APK file here"
                  uploadedLabel={fileName}
                >
                  {}
                </FileUploader>
                <div className="progressUploadBox">
                  <LinearProgress 
                    variant="determinate" 
                    value={binaryDetails.uploadProgress} 
                    sx={{
                      height: 8,
                      borderRadius: 4,
                      backgroundColor: '#E0E0E0',
                      '& .MuiLinearProgress-bar': {
                        borderRadius: 4,
                        backgroundColor: '#1976d2',
                      },
                    }}
                  />
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1, textAlign: 'center' }}>
                    {binaryDetails.uploadProgress}% Uploaded
                  </Typography>
                </div>
              </div>
            ) : (
              binaryDetails.binary &&
              Object.keys(binaryDetails.binary).length === 0 && (
                <div className="fileUploadFileDiv">
                  <label htmlFor="apk-file-upload-idle" className="labelNameAPK">APK File<span className="required">*</span></label>
                  <div className="fileLabelClsAPK">
                    Upload an APK file to create a new release of the app
                  </div>
                  <FileUploader
                    id="apk-file-upload-idle"
                    key={uploaderKey}
                    classes="fileContentClsUploadCreateNewRelease"
                    multiple={false}
                    handleChange={handleFileChange}
                    name="file"
                    label="Browse or Drag & drop the APK file here"
                    uploadedLabel={fileName}
                  >
                    {}
                  </FileUploader>
                </div>
              )
            )}
            {errors?.errorMessage != null &&
              errors?.errorType != null && <ApplicationDetailsErrorDialog />}
          </div>
        </Grid2>
      </Grid2>
    </Container>
  );
}

ApplicationFileAPKUpload.propTypes = {
  checkAllTabsAreTrue: PropTypes.func.isRequired,
};

export default ApplicationFileAPKUpload;

